<!-- 报价-竞价报价 -->
<template>
  <div>
    <!-- <el-row>
      <h2>竞价报价</h2>
    </el-row> -->
    <el-row>
      <!-- <el-tabs type="border-card" @tab-click="setSupStatus"> -->
      <!-- tab-click标签事件：tab 被选中时触发，他的返回值是被选中的标签 tab 实例 -->
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="supplier">
          <!-- SMP -->
          <span slot="label">供应商客户</span>
          <el-col v-if="supplierData">
            <el-table stripe border :data="tableData">
              <el-table-column label="序号" type="index" width="80"></el-table-column>
              <el-table-column label="公司名称" prop="GYS_NAME"></el-table-column>
              <el-table-column label="开始日期" prop="START_DAY"></el-table-column>
              <el-table-column label="结束日期" prop="END_DAY"></el-table-column>
              <el-table-column prop="STATUS" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.STATUS == 1">未报价</span>
                  <span v-if="scope.row.STATUS == 2">已报价</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button v-preventReClick type="text" @click="supplierOpenDetail(scope.row)">查看</el-button>
                  <!-- <el-button
                    v-preventReClick
                    type="text"
                    @click="deadline(scope.row)"
                    >截止时间</el-button
                  > -->
                  <el-button v-preventReClick type="text" @click="supplierOverPrice(scope.row)"
                    :disabled="scope.row.STATUS !== 1">报价完成</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-tab-pane>
        <el-tab-pane name="meal">
          <!-- supplier -->
          <span slot="label">团餐客户</span>
          <el-col v-if="mealData">
            <el-table stripe border :data="tableData">
              <el-table-column label="序号" type="index" width="80"></el-table-column>
              <el-table-column label="公司名称" prop="TC_NAME"></el-table-column>
              <el-table-column label="开始日期" prop="START_DAY"></el-table-column>
              <el-table-column label="结束日期" prop="END_DAY"></el-table-column>
              <el-table-column prop="STATUS" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.STATUS == 1">未报价</span>
                  <span v-if="scope.row.STATUS == 2">已报价</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button v-preventReClick type="text" @click="mealOpenDetail(scope.row)">查看</el-button>
                  <el-button v-preventReClick type="text" @click="mealOverPrice(scope.row)"
                    :disabled="scope.row.STATUS !== 1">报价完成</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="设置截止日期" center :visible.sync="DateVisible" width="400px" @close="closeDate">
      <el-form v-model="editDateForm" :ref="editDateForm">
        <el-form-item label="选择截止日期：">
          <el-date-picker v-model="editDateForm.DEADLINE_TIME" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:center">
        <el-button @click="closeDate">取 消</el-button>
        <el-button @click="subDate">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      pageSize: 10,
      tableData: [],
      totalCount: 0,
      currentPage: 1,
      priceStatus: 0,
      activeName: 'supplier',
      supplierData: true,
      mealData: false,
      editDateForm: {},
      DateVisible: false,
    };
  },
  methods: {
    handleCurrentChange(e) {
      if (this.activeName == 'supplier') {
        this.currentPage = e;
        this.queryTable();
      } else if (this.activeName == 'meal') {
        this.currentPage = e;
        this.mealQueryTable();
      }
    },
    // 标签页切换改变接口
    handleClick(tab, event) {
      // console.log(this.tableData);
      this.tableData = [];
      this.totalCount = 0;
      // console.log(tab, 'tab');
      this.currentOrderFlag = Number(tab.index);
      // if (Number(tab.index) == 0) {
      //   this.queryTable();
      // } else {
      //   this.mealQueryTable();
      // }
      console.log(tab.name);
      if (tab.name == 'supplier') {
        this.supplierData = true;
        this.mealData = false;
        this.queryTable();
      } else if (tab.name == 'meal') {
        this.supplierData = false;
        this.mealData = true;
        this.mealQueryTable();
      }
    },
    showtabs() {
      if (sessionStorage.getItem('activeName') != null) {
        this.activeName = sessionStorage.getItem('activeName');
        const current1 = this.activeName;
        if (current1 == 'meal') {
          this.supplierData = false;
          this.mealData = true;
          this.mealQueryTable();
        } else if (current1 == 'supplier') {
          this.supplierData = true;
          this.mealData = false;
          this.queryTable();
        }
      } else {
        this.supplierData = true;
        this.mealData = false;
        this.queryTable();
      }
    },
    // 供应商查看
    supplierOpenDetail(row) {
      this.$router.push({ name: 'givePrice' });
      sessionStorage.setItem('recordId', row.ID);
      sessionStorage.setItem('priceStatus', row.STATUS);
      sessionStorage.setItem('COMPARE_ID', row.COMPARE_ID);
    },
    // 团餐客户查看
    mealOpenDetail(row) {
      this.$router.push({ name: 'quoteDetails' });
      sessionStorage.setItem('recordId', row.ID);
      sessionStorage.setItem('priceStatus', row.STATUS);
      sessionStorage.setItem('COMPARE_ID', row.COMPARE_ID);
    },
    // 供应商接口
    queryTable() {
      const params = {
        SERVICE_ID: '10070',
        OTYPE: 1,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 团餐公司接口
    mealQueryTable() {
      const params = {
        SERVICE_ID: '10063',
        OTYPE: 1,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http
        .post(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].list;
            this.totalCount = result[0].TOTAL_COUNT;
          } else {
            this.$message.show({ text: '暂无数据', type: 'warning' });
            this.tableData = [];
            this.totalCount = 0;
          }
        })
        .catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
        });
    },
    // 供应商报价完成
    supplierOverPrice(row) {
      const params = {
        SERVICE_ID: '10070',
        OTYPE: 5,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        RECORD_ID: row.ID,
      };
      http.post(params).then((result) => {
        this.$message.show({
          text: '报价完成',
          type: 'success',
        });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    mealOverPrice(row) {
      const params = {
        SERVICE_ID: '10063',
        OTYPE: 5,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        RECORD_ID: row.ID,
      };
      http
        .post(params)
        .then((result) => {
          this.$message.show({
            text: '报价完成',
            type: 'success',
          });
          this.mealQueryTable();
        })
        .catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
        });
    },
    // 设置截止时间
    deadline(row) {
      this.DateVisible = true;
      sessionStorage.setItem('COMPARE_ID', row.COMPARE_ID);
    },
    closeDate() {
      this.DateVisible = false;
      this.editDateForm = {};
    },
    // 修改日期
    subDate() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 34,
        COMPARE_ID: Number(sessionStorage.getItem('COMPARE_ID')),
      };
      if (this.editDateForm.DEADLINE_TIME) {
        params.DEADLINE_TIME = Number(this.editDateForm.DEADLINE_TIME.split('-').join(''));
      } else {
        this.$message.show({ text: '请选择截止日期', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        if (result.length === 0) {
          this.$message.show({ text: '没有找到比价记录', type: 'warning' });
        } else {
          this.$message.show({ text: result, type: 'success' });
          this.DateVisible = false;
          this.editDateForm = {};
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.showtabs();// 跳转到指定tab
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/compareList.vue